import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { linkGreen } from '../Shared/Shared';
import { BreakPoints } from '../../Constant';

export const useProfileBlockStyles = makeStyles({
  profileContainer: {
    height: '278px',
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    gridGap: '16px',
    [BreakPoints.m]: {
      flexWrap: 'wrap',
      display: 'inline-flex',
      height: '100%',
    },
  },
  profileContainerOnChatOpen: {
    '@media (max-width: 1065px)': {
      flexWrap: 'wrap',
      display: 'inline-flex',
      height: '100%',
    },
  },
  profileCard: {
    minWidth: '249px',
    maxWidth: '249px',
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.padding('16px'),
    boxSizing: 'border-box',
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.14)',
    ...shorthands.flex('1 1 249px'),
    [BreakPoints.m]: {
      flexBasis: '100%',
      minWidth: '100%',
    },
  },
  profileCardOnChatOpen: {
    '@media (max-width: 1065px)': {
      minWidth: '100%',
    },
  },
  error: {
    rowGap: '16px !important',
  },
  roleContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.14)',
    gridGap: '16px',
    [BreakPoints.m]: {
      flexWrap: 'wrap',
    },
  },
  roleContainerOnChatOpen: {
    '@media (max-width: 1065px)': {
      flexWrap: 'wrap',
    },
  },
  frameworkStatementContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'left',
    justifyContent: 'flex-start',
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.14)',
    gridGap: '16px',
    backgroundImage: `url(/assets/CDPImage.svg)`,
    backgroundSize: 'cover',
  },
  FrameworkInnerContainer: {
    marginTop: '20px',
    marginLeft: '20px',
    width: '50%',
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    gridGap: '16px',
  },
  link: {
    color: linkGreen,
    fontSize: '14px',
    fontWeight: 400,
    textDecorationLine: 'underline',
    ':hover': {
      textDecorationLine: 'underline',
    },
    ':focus': {
      textDecorationLine: 'underline',
    },
  },
  linkDivider: {
    color: linkGreen,
    fontSize: '14px',
    fontWeight: 400,
  },
  innerCards: {
    width: '50%',
    height: '238px',
    maxHeight: '238px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
    backgroundColor: '#FAFAFA !important',
    boxShadow: 'none',
  },
  innerCardWithOutChat: {
    '@media (max-width: 639px)': {
      width: '100%',
    },
  },
  innerCardWithChat: {
    '@media (max-width: 1065px)': {
      width: '100%',
    },
  },
  textContents: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: '6px',
  },
  header: {
    height: '24px',
    maxHeight: '24px',
  },
  footer: {
    height: '16px',
    maxHeight: '16px',
  },
  divider: {
    maxHeight: '1px !important',
  },
  body: {
    height: '100%',
    flexGrow: 1,
    overflowY: 'hidden',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: '8px',
    gridGap: '9px',
    minWidth: 0,
    ...shorthands.overflow('hidden'),
  },
  tagItem: {
    backgroundColor: '#E7F2DA',
    minHeight: '24px',
    height: '100%',
  },
  tagContent: {
    whiteSpace: 'normal',
  },
  skeletonItemContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    columnGap: '16px',
    rowGap: '12px',
    height: '100%',
  },
  avatarSkeleton: {
    alignItems: 'center',
    display: 'grid',
    paddingBottom: '10px',
    position: 'relative',
    ...shorthands.gap('10px'),
    gridTemplateColumns: 'min-content 80%',
  },
  avatarSkeletonContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    columnGap: '4px',
    rowGap: '4px',
  },
  skeletonVerticalAlignment: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  skeletonRowAlignment: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    rowGap: '12px',
    columnGap: '16px',
  },
  summaryDescription: {
    fontSize: '14px',
  },
});
